import React from "react";
import Footer from "gatsby-theme-carbon/src/components/Footer";

import Title from "gatsby-theme-carbon/src/components/Title";

import { Form, TextInput, TextArea, Button } from "carbon-components-react";

const Content = ({ buildTime }) => (
  <>
    <Title>Let's Talk!</Title>
    <Form action="https://formspree.io/f/mrgdlvpg" method="POST">
      <TextInput
        helperText=""
        required="true"
        id="email"
        name="email"
        type="email"
        invalidText="Invalid email."
        labelText="Email"
        placeholder="Your email"
      />
      <TextArea
        cols={50}
        helperText=""
        required="true"
        id="message"
        name="Message"
        invalidText="Invalid message."
        labelText="message"
        placeholder="Your message"
        rows={4}
      />
      <Button kind="primary" type="submit">
        Send to Bill
      </Button>
    </Form>
    <p class="updated">Site last updated: {buildTime}</p>
    <p>Made with 🍀 in Rochester, NY</p>
  </>
);

const FooterLogo = () => (
  <img src="/images/bill-alive-logo.png" alt="[Bill Alive]" />
);

const links = {
  firstCol: [
    { href: "https://www.linkedin.com/in/billalive/", linkText: "LinkedIn" },
    { href: "https://github.com/billalive", linkText: "Github" },
    { href: "https://www.facebook.com/BillAliveAuthor/", linkText: "Facebook" },
  ],
  secondCol: [
    {
      href: "https://data.billalive.com/certification",
      linkText: "DataSci Certificate",
    },
    { href: "https://data.billalive.com", linkText: "Data Reports" },
    {
      href: "https://yarm.readthedocs.io/en/latest/",
      linkText: "Python Tool: Yarm",
    },
    { href: "https://wineskinwebsites.com", linkText: "Website Business" },
    { href: "https://billalive.com", linkText: "Fiction" },
    { href: "https://yourawesomememory.com/", linkText: "Memory Improvement" },
  ],
};

const CustomFooter = () => (
  <Footer links={links} Content={Content} Logo={FooterLogo} />
);

export default CustomFooter;
